import { useFormContext } from "react-hook-form";
import { CotationFormData } from "@/types/forms/home/cotationFormData.form";
import { FC, useState } from "react";
import usePriceDetailCard from "./usePriceDetail";
import ChevronDownIcon from "@/assets/icons/chevron-down.svg?react";
import StyledButton from "@/components/styled/StyledButton";
import clsx from "clsx";
import PriceDetailCard from "./PriceDetailCard";
import { formatPrice } from "@/lib/money.util";

interface PriceDetailCardMobileProps {
  onSubmit: () => void;
  showWinePrice: boolean;
}

const PriceDetailCardMobile: FC<PriceDetailCardMobileProps> = ({ onSubmit, showWinePrice }) => {
  const { watch } = useFormContext<CotationFormData>();
  const { priceDetail } = usePriceDetailCard();

  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => setIsOpen(true);

  const textDisplay = showWinePrice ? "Montant total" : "Tarif d'expédition";

  return (
    <>
      <div className={clsx(["fixed inset-0 bg-[#00000080] md:hidden", { hidden: !isOpen }])} />
      <div
        className={clsx(
          "fixed right-0 bottom-0 left-0 mt-6 flex flex-row items-center justify-between rounded-t-lg bg-white px-4 py-5",
          {
            "bg-blue-600": watch("express") && isOpen,
          },
        )}
      >
        <div className={clsx(["flex flex-1", { hidden: isOpen }])}>
          <div className="flex flex-1 flex-col gap-2">
            <p>{textDisplay}</p>
            <div className="flex flex-row items-center gap-2" onClick={handleOpen}>
              <span className="font-jakarta-sans text-3xl font-bold text-blue-600">
                {formatPrice(
                  (showWinePrice
                    ? priceDetail?.priceWWine?.totalPriceWWine
                    : priceDetail?.totalPrice) || 0,
                )}
              </span>
              <ChevronDownIcon className="text-gray-400" />
            </div>
          </div>
          <StyledButton mode="primary" onClick={onSubmit} className="h-11 w-40!">
            Continuer
          </StyledButton>
        </div>

        <div className={clsx(["flex flex-1", { hidden: !isOpen }])}>
          <PriceDetailCard
            showWinePrice={showWinePrice}
            mobileOpenState={isOpen}
            setMobileOpenState={setIsOpen}
          />
        </div>
      </div>
    </>
  );
};

export default PriceDetailCardMobile;
